module.exports = __webpack_public_path__ + "img/IMG_20191126_235547.a3854af4.jpg";